import { recordLoginAiCapabilities } from '@/ai/services/api'
import { getLoginRedirect } from '@/common/auth-navigation'
import { recordLoginServerApiLevel } from '@/common/compatibility/server-api-level'
import vm from '@/main'
import store from 'store/index' ///导入公共仓库
////引入地图模块的js文件
import getCurrentCityName from 'common/getUserLocation'

////正常登录
const logiBtnHandle = userinfo => {
  // vm.$router.replace('/controlpage')
  // return;

  ///对输入的信息进行检查
  console.log(userinfo.id)
  if (userinfo.id === undefined) {
    vm.$toast('账号不能为空！')
    return
  } else if (userinfo.passWord === '') {
    vm.$toast('密码不能为空！')
    return
  }
  //////登录接口
  vm.$request({
    method: 'post',
    url: '/user/login',
    data: {
      account: userinfo.id,
      type: '1',
      password: userinfo.passWord
    }
  })
    .then(res => {
      ///请求接口成功
      console.log(res)
      if (res.data.code == 0) {
        ///说明密码正确，登录成功
        // vm.$router.replace('/mainTabBar')
        // vm.$router.replace('/controlpage')
        loginSuccessHandle(res.data.data, userinfo)

        ////  高德地图获取定位城市
        getCurrentCityName()
          .then(city => {
            console.log(city) //顺利的话能在控制台打印出当前城市
            sessionStorage['positionCity'] = city /////获取的城市存入浏览器缓存
          })
          .catch(err => {
            console.log(err + ' 高德地图获取定位城市失败!')
          })

        // vm.$toast(res.data.message)
      } else {
        vm.$toast(res.data.message.replace('[', '').replace(']', '') + '!') ///去除服务端传来的无用字符串及增加！号
      }
    })
    .catch(err => {
      console.log(err)
    })
}

////演示登录
const loginYanShiBtnHandle = userinfo => {
  // vm.$router.replace('/controlpage')
  // return;

  ///对输入的信息进行检查
  // console.log(userinfo.id)
  // if (userinfo.id === undefined) {
  //   vm.$toast('账号不能为空！')
  //   return
  // } else if (userinfo.passWord === '') {
  //   vm.$toast('密码不能为空！')
  //   return
  // }
  //////登录演示界面
  vm.$request({
    method: 'post',
    url: '/user/loginDemo',
    data: {
      phone: userinfo.id,
      code: userinfo.code
    }
  })
    .then(res => {
      ///请求接口成功
      console.log(res)
      if (res.data.code == 0) {
        ///说明密码正确，登录成功
        // vm.$router.replace('/mainTabBar')
        // vm.$router.replace('/controlpage')
        loginSuccessHandle(res.data.data, userinfo)

        ////  百度地图获取定位城市
        getCurrentCityName()
          .then(city => {
            console.log(city) //顺利的话能在控制台打印出当前城市
            sessionStorage['positionCity'] = city /////获取的城市存入浏览器缓存
          })
          .catch(err => {
            console.log(err + ' 百度地图获取定位城市失败!')
          })

        // vm.$toast(res.data.message)
      } else {
        vm.$toast(res.data.message.replace('[', '').replace(']', '') + '!') ///去除服务端传来的无用字符串及增加！号
      }
    })
    .catch(err => {
      console.log(err)
    })
}
const loginSuccessHandle = (data, userinfo) => {
  const redirect = getLoginRedirect(vm.$router, vm.$route.query.redirect)
  recordLoginServerApiLevel(vm, data)
  store.dispatch('asyResetRegionNavigation')
  store.dispatch('asyUpdataUserId', data.userId)
  store.dispatch('asyUpdataLoginAccount', userinfo.id)
  ///永久存储浏览器缓存  除非手动删除
  // localStorage.clear()
  // localStorage.setItem('info',1)////方法1
  // localStorage['flag']=1////方法2
  // localStorage.setItem('flag',1)

  ////浏览器关闭之前存储数据     存储token
  // sessionStorage.clear()
  // sessionStorage['userid']=JSON.stringify(res.data.userInfo.id)
  // sessionStorage.setItem('userid',JSON.stringify(res.data.userInfo.id))
  sessionStorage['token'] = data.token
  sessionStorage['nickName'] = data.nickName ///用户昵称存入浏览器缓存
  sessionStorage['userType'] = data.userType ///用户类型存入浏览器缓存  0主账号  1子账号
  sessionStorage['account'] = userinfo.id ///用户账号存入浏览器缓存
  sessionStorage['userId'] = data.userId ///y用户ID存入浏览器缓存，用于soket链接
  recordLoginAiCapabilities(data)

  ////下面这一句不能去掉，去掉会在路由拦截判断的时候出问题
  store.dispatch('asyUpdataToken', data.token) ///异步提交用户的账号信息到仓库
  if (data.userType === 0) {
    ///说明登录的是主账号
    if (data.offLineList.length === 0 && data.onLineList.length === 0) {
      ///说明用户的账号一个设备都没有关联
      store.dispatch('asyUpdatabindHostState', 0) ///异步提交绑定主机状态到仓库//暂时无用
      sessionStorage['bindHostState'] = 0 ////提交绑定主机状态到浏览器缓存
      console.log('用户还没有绑定设备登录了')
      if (redirect) {
        ///如果是拦截回来的页面，登录成功后返回到登录之前的页面
        vm.$router.replace(redirect)
      } else {
        ////或者是正常登录的绑定设备页面
        vm.$router.replace('/firstEntry')
      }
    } else {
      ////说明用户的账号已经绑定过设备
      store.dispatch('asyUpdatabindHostState', 1) ///异步提交绑定主机状态到仓库//暂时无用
      sessionStorage['bindHostState'] = 1 ////提交绑定主机状态到浏览器缓存

      console.log('主账号登录成功')
      if (redirect) {
        ///如果是拦截回来的页面，登录成功后返回到登录之前的页面
        vm.$router.replace(redirect)
      } else {
        ////或者是正常登录的页面
        vm.$router.replace('/controlpage')
      }
      //   setTimeout(() => {
      //   }, 3500)
    }
  } else if (data.userType === 1) {
    ///说明登录的是子账号
    console.log('子账号登录成功')
    if (redirect) {
      ///如果是拦截回来的页面，登录成功后返回到登录之前的页面
      vm.$router.replace(redirect)
    } else {
      ////或者是正常登录的页面
      vm.$router.replace('/controlpage')
    }
  }
}
export { logiBtnHandle, loginYanShiBtnHandle }
